import PropTypes from 'prop-types';
import React, {
  createContext, useContext, useMemo, useState,
} from 'react';

export const PropertyDatespanContext = createContext(null);

/**
 * Custom hook to access the PropertyDatespanContext values from any component in the tree.
 * @returns {object} The current PropertyDatespanContext value containing datespan state
 * and methods
 */
export function usePropertyDatespan() {
  return useContext(PropertyDatespanContext);
}

/**
 * Provider component that manages property datespan state and functionality.
 * Provides datespan-related state and methods to child components via context.
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - Child components that will have access to
 * the property datespan context
 * @returns {React.ReactNode} The provider component wrapping the children with the
 * PropertyDatespanContext
 */
function PropertyDatespanProvider({ children }) {
  const [datespanStart, setDatespanStart] = useState(null);

  const value = useMemo(() => ({
    datespanStart,
    setDatespanStart,
  }), [datespanStart]);

  return (
    <PropertyDatespanContext.Provider value={value}>
      {children}
    </PropertyDatespanContext.Provider>
  );
}

PropertyDatespanProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PropertyDatespanProvider;
